import React, { useState } from 'react';

const ContactSubmitForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        select: ''
    });

    const [message, setMessage] = useState({ text: '', isVisible: false });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const contactSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage({ text: '', isVisible: false });
        const { name, email, phone, select } = formData;

        const data = new URLSearchParams();
        data.append('name', name);
        data.append('email', email);
        data.append('phone', phone);
        data.append('subject', select);

        try {
            const response = await fetch('https://smartresourcesqld.com.au/contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: data.toString()
            });

            const result = await response.text();
            const normalizedResult = result.trim().toLowerCase();

            if (normalizedResult === 'ok') {
                setMessage({ text: 'Submitted Successfully', isVisible: true });
            } else {
                setMessage({ text: 'Something went wrong! Please try again later.', isVisible: true });
            }

            // Optionally, reset the form
            setFormData({
                name: '',
                email: '',
                phone: '',
                select: ''
            });

        } catch (error) {
            console.error('Error:', error);
            setMessage({ text: 'Error occurred! Please try again later.', isVisible: true });
        } finally {
            setIsSubmitting(false);
        }

        // Hide message after 5 seconds
        setTimeout(() => {
            setMessage({ text: '', isVisible: false });
        }, 5000);
    };

    return (
        <form onSubmit={contactSubmit}>
            <div className="row">
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_name">Name</label>
                        <input
                            type="text"
                            id="contact_name"
                            name="name"
                            placeholder="Your Name*"
                            required
                            className="form-control name-control name_text"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_email">Email</label>
                        <input
                            type="email"
                            id="contact_email"
                            className="form-control name_text name-control"
                            name="email"
                            placeholder="Your Email*"
                            required
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_phone">Phone</label>
                        <input
                            type="tel"
                            id="contact_phone"
                            className="form-control name_text name-control"
                            name="phone"
                            placeholder="Your Phone*"
                            required
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12">
                    <div className="name_field">
                        <label htmlFor="contact_select">Select a subject to get help*</label>
                        <select
                            id="contact_select"
                            className="form-control name_text name-control name_select"
                            name="select"
                            value={formData.select}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Choose an option</option>
                            <option value="Success Fulfill">Success Fulfill</option>
                            <option value="Startup Business">Startup Business</option>
                            <option value="Business Growth">Business Growth</option>
                            <option value="Leadership Work">Leadership Work</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-12">
                    <button type="submit" className="submit_button consult_submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Submit now'}
                    </button>
                </div>
                {isSubmitting && (!message.isVisible) && (
                    <div className="col-lg-12">
                        <div className="alert alert-info" role="alert">
                            Loading...
                        </div>
                    </div>
                )}
                {message.isVisible && (
                    <div className="col-lg-12">
                        <p className="alert alert-info">
                            {message.text}
                        </p>
                    </div>
                )}
            </div>
        </form>
    );
};

export default ContactSubmitForm;
